
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import PinResetStore from "../stores/PinResetStore";
import { PinResetLandingPage } from "./PinResetLandingPage";
import { PinResetSigning } from "./PinResetSigning";
import { PinSuccess } from "./PinSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class PinResetContainer extends React.Component<IProps, {}> {
    pinResetStore: PinResetStore;

    constructor(props: any) {
        super(props);
        this.pinResetStore = new PinResetStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized && this.props.externalInterfaceStore.currentCardId) {
                await this.pinResetStore.load(this.props.externalInterfaceStore.currentCardId);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} pinResetStore={this.pinResetStore} />;
    }

    render() {
        document.title = ui.__("pin.document.title");

        return (
            <div>
                <Route exact path={this.props.match.path} render={this.withStore(PinResetLandingPage)} />
                <Route path={this.props.match.path + "/signing"} render={this.withStore(PinResetSigning)} />
                <Route path={this.props.match.path + "/success"} render={this.withStore(PinSuccess)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pin/views/PinResetContainer.tsx